import {UserActionPageData, UserState} from './models';
import { Logger } from './logger';

export class UserActionPageDataProvider
{
    static _storageName = "ai_userActionPageDataProvider";

    static get(href)
    {
      let storage = {};
      let pageData = null;
      if(sessionStorage.getItem(this._storageName) != null)
      {
        storage = JSON.parse(sessionStorage.getItem(this._storageName));
      }

      try
      {
        pageData = storage[href];
      }
      catch(ex)
      {
        console.log(ex);
        //Logger.logError(ex, "UserActionPageDataProvider.get", "", "");
      }

      if(pageData == null)
      {
        pageData = new UserActionPageData();
        pageData.href = href;
      }
      return pageData;

    }
    static set(pageData)
    {
      let storage = {};
      if(sessionStorage.getItem(this._storageName) != null)
      {
        storage = JSON.parse(sessionStorage.getItem(this._storageName));
      }
      storage[pageData.href] = pageData;
      sessionStorage.setItem(this._storageName, JSON.stringify(storage));

    }
}

export class UserConversionProvider
{
  static _storageName = "ai_userConversionProvider"

  static get(id)
  {
    let storage = [];
    if(localStorage.getItem(this._storageName) != null)
    {
      storage = JSON.parse(localStorage.getItem(this._storageName));
    }
    let exist = storage.includes(id);
    return exist;
  }

  static set(id)
  {
    let storage = [];
    if(localStorage.getItem(this._storageName) != null)
    {
      storage = JSON.parse(localStorage.getItem(this._storageName));
    }
    if(id == null || id == "")
    {
        return;
    }
    storage.push(id)
    localStorage.setItem(this._storageName, JSON.stringify(storage));
  }
}

export class UserSessionProvider
{
   static _storageName = "ai_userSession";

   static get()
   {
      let userSession = null;
      if(localStorage.getItem(this._storageName) != null)
      {
        userSession = JSON.parse(localStorage.getItem(this._storageName));
      }
      return userSession;
   }
   static set(session)
   {
      localStorage.setItem(this._storageName, JSON.stringify(session));
   }
}

export class UserStateProvider
{
    static _storageName = "ai_userState";
    
    static get()
    {
      let userState = null;
      if(localStorage.getItem(this._storageName) == null)
      {
        userState = new UserState();
        localStorage.setItem(this._storageName, JSON.stringify(userState));
      }
      else
      {
        userState = JSON.parse(localStorage.getItem(this._storageName));
      }
      return userState;
    }

    static set(userState)
    {
      localStorage.setItem(this._storageName, JSON.stringify(userState));
      return userState;
    }

    static isFcSessionDataAvailable()
    {
        let userState = this.get();
        if(userState.fcSessionId != null)
        {
          return true;
        }
        return false;
    }
}